import React, { useContext } from "react";
import { Switcher } from "../view/Switcher";
import { TableContext } from "../index";
import { Checkbox } from "../view/Checkbox";
import { deepCopy } from "../utils";
import * as recipientService from "./mailRecipientService";

function AdditionalRecipientTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);

    const onEnableAlertClick = async (value) => {
        const recipient = deepCopy(data);
        recipient.enableAlerting = value;
        await recipientService.update(recipient);
        setConfig({ ...config, lastUpdated: Date.now() });
    }

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>            
            <td>
                {data.firstName}
            </td>
            <td>
                {data.lastName}
            </td>
            <td>
                {data.email}
            </td>
            <td>
                <div>
                    {/* <div className="custom-control custom-switch"> */}
                        <Switcher value={data.enableAlerting} onClick={onEnableAlertClick} />
                    {/* </div> */}
                </div>
            </td>
        </tr>
    )


}

export default AdditionalRecipientTableRow;